import React from 'react';

// tslint:disable max-line-length
const CLetThemKnowPart3TranscriptMunch: React.FC = () => (
  <>
    <h5>Record a message for part 3</h5>
    <p>It’s time to record your final message. Someone gave me this advice recently. They said to me – don’t worry about explaining too much. That’s it. I just thought, you know, it could help... So, is there a thought you want to leave them with?</p>
  </>
);

export {
  CLetThemKnowPart3TranscriptMunch,
};
